import { render, staticRenderFns } from "./purchaseMethodDetailInfo.vue?vue&type=template&id=af901108&scoped=true&"
import script from "./purchaseMethodDetailInfo.vue?vue&type=script&lang=js&"
export * from "./purchaseMethodDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./purchaseMethodDetailInfo.vue?vue&type=style&index=0&id=af901108&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af901108",
  null
  
)

export default component.exports